// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/EntityTemplate.yaml
// Generated: 2026-06-17T14:53:26.334Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateEntityTemplate, UpdateEntityTemplate, EntityTemplate } from '@/types/core/EntityTemplate';

/**
 * EntityTemplate Service
 * CRUD operations for EntityTemplate via the ABP API.
 */
export const entityTemplateService = new EntityService<EntityTemplate, CreateEntityTemplate, UpdateEntityTemplate>(
  '/api/core/entitytemplate',
  'EntityTemplate',
);
